import React from "react";
import { Typography } from "antd";

export const QuestionNameInput: React.FC<{value?: any, onChange?: any}> = ({value, onChange}) => {

    return <Typography.Text 
        // className="bg-red-300" 
        editable={{onChange}}>
        {value}
    </Typography.Text>;
};
